const PostAssistant = {
  text: "",
  platform: "linkedin",
  goal: "",
  content_pillar: null,
  content_type: "",
  tone: "",
  post_type: "",
};

export default PostAssistant;
